import { call } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { launchPollRequested } from 'features/polls/actions';

export function* launchPollSaga(action: ReturnType<typeof launchPollRequested>) {
  yield call(SignalingSocket.send, { event: 'launchPoll', data: { id: action.payload } });
}
